import { render, staticRenderFns } from "./PreviewMateri.vue?vue&type=template&id=3bc05eae"
import script from "./PreviewMateri.vue?vue&type=script&lang=js"
export * from "./PreviewMateri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports